/** Drop "Reusable" from create/edit menu item titles when the redesign flag is on. */
export const getMenuItemDialogTitle = (title: string, isRedesign: boolean): string => {
  if (!isRedesign) {
    return title;
  }
  return title.replace(/\bReusable\s+/g, "");
};
